import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_locate-loved-ones-3/artifacts/5wufybp4_LOGO.jpeg";
const SUPPORT_EMAIL = "contact@misyou.in";
const SUPPORT_PHONE = "+91 8146499739";

export default function SiteFooter() {
  return (
    <footer className="bg-slate-900 text-slate-300 mt-16" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-3">
              <img src={LOGO_URL} alt="MISYOU" className="w-8 h-8 rounded-lg object-cover" />
              <span className="font-bold text-white text-lg">MISYOU</span>
            </Link>
            <p className="text-sm text-slate-400 leading-relaxed">
              Helping families reunite with missing loved ones through community-driven search and verified reporting.
            </p>
          </div>

          {/* Product */}
          <div>
            <h4 className="text-white font-semibold mb-3 text-sm uppercase tracking-wide">Product</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/search" className="hover:text-white transition-colors">Search cases</Link></li>
              <li><Link to="/report-case" className="hover:text-white transition-colors">Report missing</Link></li>
              <li><Link to="/pricing" className="hover:text-white transition-colors" data-testid="footer-pricing-link">Pricing</Link></li>
              <li><Link to="/subscription" className="hover:text-white transition-colors">Subscription</Link></li>
              <li><Link to="/qr" className="hover:text-white transition-colors">Share via QR</Link></li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-white font-semibold mb-3 text-sm uppercase tracking-wide">Company</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/about" className="hover:text-white transition-colors" data-testid="footer-about-link">About us</Link></li>
              <li><Link to="/contact" className="hover:text-white transition-colors" data-testid="footer-contact-link">Contact us</Link></li>
              <li><Link to="/privacy" className="hover:text-white transition-colors">Privacy policy</Link></li>
              <li><Link to="/terms" className="hover:text-white transition-colors">Terms & Conditions</Link></li>
              <li><Link to="/refund" className="hover:text-white transition-colors" data-testid="footer-refund-link">Refund & Cancellation</Link></li>
              <li><Link to="/anti-harassment" className="hover:text-white transition-colors" data-testid="footer-anti-harassment-link">Anti-Harassment Policy</Link></li>
              <li><Link to="/disclaimer" className="hover:text-white transition-colors">Disclaimer</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold mb-3 text-sm uppercase tracking-wide">Contact</h4>
            <ul className="space-y-3 text-sm">
              <li>
                <a href={`mailto:${SUPPORT_EMAIL}`} className="flex items-start gap-2 hover:text-white transition-colors">
                  <Mail className="w-4 h-4 mt-0.5 shrink-0" />
                  <span>{SUPPORT_EMAIL}</span>
                </a>
              </li>
              <li>
                <a href="tel:+918146499739" className="flex items-start gap-2 hover:text-white transition-colors">
                  <Phone className="w-4 h-4 mt-0.5 shrink-0" />
                  <span>{SUPPORT_PHONE}</span>
                </a>
              </li>
              <li className="flex items-start gap-2">
                <MapPin className="w-4 h-4 mt-0.5 shrink-0" />
                <span>
                  St. No.-05, Natt Road,<br />
                  SBS Nagar, Talwandi Sabo,<br />
                  Bathinda, Punjab &ndash; 151302, India
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-10 pt-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-xs text-slate-500">
            © {new Date().getFullYear()} MISYOU. All rights reserved.
          </p>
          <p className="text-xs text-slate-500 text-center md:text-right">
            MISYOU is individually owned by Dinesh Bansal &middot; Made with care for families everywhere.
          </p>
        </div>
      </div>
    </footer>
  );
}
